import { render } from "./Curtain.vue?vue&type=template&id=5ff4cf3c&scoped=true"
import script from "./Curtain.vue?vue&type=script&lang=js"
export * from "./Curtain.vue?vue&type=script&lang=js"

import "./Curtain.vue?vue&type=style&index=0&id=5ff4cf3c&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ff4cf3c"]])

export default __exports__